
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import {useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import styled from "styled-components";
import Slider from '@mui/material/Slider';
import AirportCarousel from '../../components/AirportCarousel';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Checkbox from '@mui/material/Checkbox';

import {PlotSectionDiv, EpochDataBlock} from '../../components/DisplayComponents';
import {PlotLoadingOverlay} from '../../components/PlotLoadingOverlay';


const DEG_TO_NM   = 60.0405
const NM_TO_DEG   = 1/DEG_TO_NM

// const DetailedSummaryOverlayDivStyle = styled.div`
  // position: fixed;
  // text-align:center;
  // justify:center;
  // display:block;
  // flex: none;
  // top:0;
  // bottom:0;
  // left:0;
  // right:0;
  // padding-top:10%;
  // width: 100%;
  // height: 100%;
  // background-color: rgba(0,0,0,0.5); 
  // z-index: 17; 
  // cursor: pointer;
// `;

// const OverlaychartPlotDivStyle = styled.div`
  // display:block;
  // flex:none;
  // justify-content: center;
  // align-items: center;
// `;

// const DetailedSummaryOverlayDiv = ()=>{
        // return(
            // <div style={{position:"fixed",zIndex:15}} >
            // <DetailedSummaryOverlayDivStyle>
                // <OverlaychartPlotDivStyle id="overlayPlot" onClick={handleOverlayClick}>
                // <Plot  data={[{
                    // x: metroplexEncroachmentDataAll.epochString,
                    // y: metroplexEncroachmentDataAll.encrDur.Total,
                    // type: 'scatter',
                    // mode: 'lines+markers',
                    // marker: {color: 'red'},
                  // },
                // ]}
                // id="chartPlotDiv"
                // layout={ {title: 'Detailed Summary',width:600,height:400} }
              // />
              // </OverlaychartPlotDivStyle>
            // </DetailedSummaryOverlayDivStyle>
            // </div>
            // );
    // };

const Layout = styled.div`
    display:flex;
    flex:1 1;
    width:100vh;
    justify-content:flex-start;
    flex-wrap:wrap;
    gap: 10px 10px;
    max-height: calc(100vh - 150px);
`;

  
const TitleDiv = styled.div`
    min-width:85vw;
`;

const colorPalette = ['#2E91E5','#E15F99','#1CA71C','#FB0D0D','#DA16FF','#222A2A','#B68100','#750D86','#EB663B','#511CFB',
					'#FB0D0D','#DA16FF','#222A2A']


const turbCountSectors = ['North','Northeast','East','Southeast','South','Southwest','West','Nortwest']

const zoomPlusEvent = new KeyboardEvent('keydown', {
  key: '+',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

const zoomMinusEvent = new KeyboardEvent('keydown', {
  key: '-',           // The key value ('+' for plus)
  code: 'Equal',      // The physical key code (often 'Equal' for '+')
  keyCode: 187,       // The keyCode for '=' which also serves as '+'
  which: 187,         // The which value, same as keyCode
  ctrlKey: true,      // Indicates that Ctrl is pressed
  shiftKey: true,     // Shift is usually needed for the '+' sign
  bubbles: true,      // If the event should bubble up through the DOM
  cancelable: true    // If the event is cancelable
});

// <TitleDiv>
            // <h1 style={{marginLeft:'10px'}}>{airport+', '+airportData['city']+' - Mashup Dashboard'}</h1>
        // </TitleDiv>

const sliderMarks = [
  {
    value: 0,
    label: '5 min',
  },
  {
    value: 1,
    label: '1 hour',
  },
  {
    value: 2,
    label: '24 hours',
  },
];
function correctAirportFormat(airportObj){
  return(airportObj['airport'].toUpperCase())
}

const MAP_TIME_RANGE_VALUES = ['5min','1hr','24hr']
const mapMetricValues = ['turbulence','flightplanchanges']
//const turbulenceIntensityScale = {'UNKWN':0,'NEG':1,'LGT':2,'LGT-MOD':3,'MOD':4,'MOD-SEV':5,'SEV':6,'SEV-EXTM':7,'EXTM':8}
const TURB_INTENSITY_SCALE = [0,8]
const apiSuffix = {'turbulence':'get-turbulence-events','flightplanchanges':'get-flight-plan-change-events'}

// A metric endpoint that fails upstream comes back as {} (or []) rather than the expected
// {epochString:[...], ...} shape. Spreading `...undefined` from a missing key throws, which used to
// kill the whole response handler mid-way (charts never render, map stays stuck loading). Coerce the
// windowed metrics payload to well-formed arrays so every downstream spread is safe.
const asArray = (x) => (Array.isArray(x) ? x : [])
function normalizeWindowedMetrics(jsonData){
  const m = jsonData || {}
  const enc = m.metroplexEncroachmentData || {}
  const encDur = enc.encrDur || {}
  const cl = m.centerlineDevData || {}
  const ga = m.goAroundCountData || {}
  const fpc = m.flightPlanChangeCountData || {}
  const turb = m.turbulenceCountData || {}
  return {
    metroplexEncroachmentData: {
      ...enc,
      epochString: asArray(enc.epochString),
      encrDur: { ...encDur, Total: asArray(encDur.Total), Adjusted: asArray(encDur.Adjusted) },
    },
    centerlineDevData: {
      ...cl,
      epochString: asArray(cl.epochString),
      meanCenterlineDeviation_mean: asArray(cl.meanCenterlineDeviation_mean),
    },
    goAroundCountData: {
      ...ga,
      epochString: asArray(ga.epochString),
      goAround15min: asArray(ga.goAround15min),
      holdingPattern15min: asArray(ga.holdingPattern15min),
    },
    flightPlanChangeCountData: {
      ...fpc,
      epochString: asArray(fpc.epochString),
      '5min': asArray(fpc['5min']),
    },
    turbulenceCountData: {
      ...turb,
      epochString: asArray(turb.epochString),
      All: asArray(turb.All),
    },
  }
}

const AirportSummary = ({setTitle,pageTitle,metricLookBackHorizonDays,backendApiPrefix}) => {
    
    const airport = correctAirportFormat(useParams())


    useEffect(() => {
        setTitle(pageTitle=>'Airport Summary - '+airport)
    },[airport]);
    const [isChartLoading,setIsChartLoading] = useState(true)
    const [isMapLoading,setIsMapLoading] = useState(true)
    const [lastUpdatedTime,setLastUpdatedTime] = useState(new Date())
    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))
    const [airportMapTrace,setAirportMapTrace] = useState({type: "scattermapbox",
                                                           lat: [],
                                                           lon: [],
                                                           text:[],
                                                           textfont:{size:16,color:'black'},
                                                           textposition:'top right',
                                                           marker: {symbol:'marker',color: "black", size: 10,allowoverlap:true},
                                                           hoverinfo:'skip',
                                                           name:'',
                                                           mode:'markers+text',
                                                           hovertemplate:'<extra></extra>',
                                                           showlegend:false})
    // const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
    //                                         'toggleSpikelines','select2d',
    //                                         'zoomIn2d','zoomOut2d','lasso2d'],
    //                                          displaylogo:false,responsive:true})
  
    const [plotConfig,setPlotConfig] = useState({modeBarButtonsToRemove:['toImage','zoom2d',
                                            'toggleSpikelines','select2d',
                                            'zoomIn2d','zoomOut2d','lasso2d',
                                            'pan2d','autoScale2d', 'resetScale2d','hoverClosestCartesian',
                                            'hoverCompareCartesian','zoom3d','pan3d', 'resetCameraDefault3d',
                                            'resetCameraLastSave3d', 'hoverClosest3d', 'orbitRotation', 
                                            'tableRotation', 'zoomInGeo', 'zoomOutGeo', 'resetGeo', 
                                            'hoverClosestGeo', 'toImage', 'sendDataToCloud', 'hoverClosestGl2d',
                                            'hoverClosestPie', 'toggleHover', 'resetViews', 'toggleSpikelines', 'resetViewMapbox'],
                                              displaylogo:false,responsive:true})
    const [plotStyle,setPlotStyle] = useState({width:'100%',height:'100%'})
    const [revision,setRevision] = useState(0)
    const [airportData, setAirportData] = useState({'location':[],'city':''}); 
    const [metroplexEncroachmentDataAll, setMetroplexEncroachmentDataAll] = useState({epochString:[],encrDur:{Total:[],Adjusted:[]}}); 
    const [centerlineDeviationDataAll, setCenterlineDeviationDataAll] = useState({epochString:[],meanCenterlineDeviation_mean:[]}); 
    const [goAroundCountDataAll, setGoAroundCountDataAll] = useState({epochString:[],goAround15min:[],holdingPattern15min:[]}); 
    const [flightPlanChangeCountDataAll, setFlightPlanChangeCountDataAll] = useState({epochString:[],Count5min:[]}); 
    const [turbulenceCountDataAll, setTurbulenceCountDataAll] = useState({epochString:[],Total15min:[]}); 
    const [highlightYMarker,setHighlightYMarker] = useState({'index':1,'index2':1,'index3':1,'index4':1,'index5':1,'index6':1})

    const [selectedEpoch,setSelectedEpoch] = useState('')
    const [latestEpochFlag,setLatestEpochFlag] = useState(true)

    const [plotMapLayout, setPlotMapLayout] = useState({
                                                        mapbox: 
                                                        { style: "light", 
                                                        zoom:7,
                                                        accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
                                                        domain:{'x':[0.01,1],'y':[0.01,0.99]}
                                                        },
                                                        margin:{l:10,t:10,r:12,b:10},
                                                        xaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
                                                        yaxis:{showline:true, linewidth:10, linecolor:'black', mirror:true},
                                                        showlegend:false,plot_bgcolor:'rgba(220,232,247,0.4)'
                                                        },
                                                        );
    const [plotChartLayout, setPlotChartLayout] = useState({grid:{rows:6,columns:1,xside:'bottom plot',ygap:0.2},
                                                                xaxis:{anchor:'y',
                                                                        rangeselector:{
                                                                          x:0,y:1.01,
                                                                          xanchor:'left',
                                                                        buttons:[{count:1,label:'1hr',step:'hour',stepmode:'backward'},
                                                                                 {count:12,label:'12hrs',step:'hour',stepmode:'backward'},
                                                                                 {count:1,label:'1d',step:'day',stepmode:'backward'},
                                                                                 {step:'all'}]},
                                                                        type:'date',
                                                                        zeroline:false},
                                                                sharedx:true,
                                                                hovermode:'x unified',
                                                                showlegend:false,
                                                                height:1000,
                                                                yaxis:{anchor:'x',zeroline:false,'title':'Adj. Encroachment<br>Duration [s]'},
                                                                yaxis2:{anchor:'x2',zeroline:false,'title':'Mean Centerine<br>Deviation [ft]'},
                                                                yaxis3:{anchor:'x3',zeroline:false,'title':'GoAround Counts<br>per 15min'},
                                                                yaxis4:{anchor:'x4',zeroline:false,'title':'Holding Pattern<br> Counts per 15min'},
                                                                yaxis5:{anchor:'x5',zeroline:false,'title':'FlightPlan Change<br> Counts per 15min'},
                                                                yaxis6:{anchor:'x6',zeroline:false,'title':'Turbulence <br> Counts per 15min'},
                                                                margin:{t:54,r:10,b:10},
                                                                plot_bgcolor:'rgba(220,232,247,0.4)'}
                                                                );
    
    const [leftDivHeight, setLeftDivHeight] = useState(null);
    const [leftDivWidth, setLeftDivWidth] = useState(null);
    
    const [rightDivHeight, setRightDivHeight] = useState(null);
    const [rightDivWidth, setRightDivWidth] = useState(null);
    
    const [revKey, setRevKey] = useState(0);
    const [mapTimeRange,setMapTimeRange] = useState(MAP_TIME_RANGE_VALUES[0])
    const [mapData,setMapData] = useState({'5min':{},'1hr':{},'24hr':{}})
                                                                
    const [mapPlotTraces,setMapPlotTraces] = useState([])
    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     setLastUpdatedTime(new Date())
    //     getLatestMetricData()
    //   }, 10000);
    //   return () => clearInterval(interval);
    // }, [airportData]);

    useEffect(() =>{
      setTimeout(()=>{
      setPlotChartLayout({...plotChartLayout,
                          width:0.98*leftDivWidth
                        });
      
      // setPlotMapLayout({...plotMapLayout,
                       // width:0.98*rightDivWidth,
                       // });
                       
      setPlotMapLayout({...plotMapLayout,
                           width:0.98*rightDivWidth,
                           mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    },
                            zoom:7});
                                    
      setAirportMapTrace({...airportMapTrace,
                        lat: [airportData['location'][0]],
                        lon: [airportData['location'][1]],
                        text:[airport],
                        name:airport,
                        hovertemplate:'<extra></extra>'+airport,
                        })
                       
      },20)
    },[leftDivWidth,rightDivWidth,airportData]);
    
    function resetMetricStates(){
      setQueryIterTime(new Date())
      setMetricStartTime(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))
      setMetroplexEncroachmentDataAll({epochString:[],encrDur:{Total:[],Adjusted:[]}}); 
      setCenterlineDeviationDataAll({epochString:[],meanCenterlineDeviation_mean:[]}); 
      setGoAroundCountDataAll({epochString:[],goAround15min:[],holdingPattern15min:[]}); 
      setFlightPlanChangeCountDataAll({epochString:[],Count5min:[]}); 
      setTurbulenceCountDataAll({epochString:[],Total15min:[]}); 
  };

    useEffect(() => {
        // resetMetricStates()
        axios.post(backendApiPrefix+'/api/get-airport-data/',{airport:airport})
            .then(response => {
                var jsonData = response.data.message
                console.log(jsonData)
                setAirportData(jsonData)
            })
            .catch(error => {
                console.log(error);
            });
    },[airport]);
    
    
    useEffect(() => {
      var QUERY_CHUNK_HOURS = 1;
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - QUERY_CHUNK_HOURS* 60*60*1000)
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
            axios.post(backendApiPrefix+'/api/get-metrics-all/',{airport:airport,from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
                  .then(response => {
                    QUERY_CHUNK_HOURS += 1;
                    var jsonData = normalizeWindowedMetrics(response.data.message)
                    setQueryIterTime(shiftedQueryIterTime)
                    setMetroplexEncroachmentDataAll({...metroplexEncroachmentDataAll,
                      epochString:[...jsonData.metroplexEncroachmentData.epochString,...metroplexEncroachmentDataAll.epochString],
                      encrDur:{
                          Total:[...jsonData.metroplexEncroachmentData.encrDur.Total,...metroplexEncroachmentDataAll.encrDur.Total],
                          Adjusted:[...jsonData.metroplexEncroachmentData.encrDur.Adjusted,...metroplexEncroachmentDataAll.encrDur.Adjusted]
                        }})
                    setCenterlineDeviationDataAll({...centerlineDeviationDataAll,
                                          epochString:[...jsonData.centerlineDevData.epochString,
                                                       ...centerlineDeviationDataAll.epochString],
                                          meanCenterlineDeviation_mean:[...jsonData.centerlineDevData.meanCenterlineDeviation_mean,
                                                                        ...centerlineDeviationDataAll.meanCenterlineDeviation_mean]})
                    setGoAroundCountDataAll({...goAroundCountDataAll,
                                          epochString:[...jsonData.goAroundCountData.epochString,
                                                       ...goAroundCountDataAll.epochString],
                                          goAround15min:[...jsonData.goAroundCountData.goAround15min,
                                                         ...goAroundCountDataAll.goAround15min],
                                          holdingPattern15min:[...jsonData.goAroundCountData.holdingPattern15min,
                                                               ...goAroundCountDataAll.holdingPattern15min]})

                    setFlightPlanChangeCountDataAll({...flightPlanChangeCountDataAll,
                                          epochString:[...jsonData.flightPlanChangeCountData.epochString,
                                                       ...flightPlanChangeCountDataAll.epochString],
                                          Count5min:[...jsonData.flightPlanChangeCountData['5min'],
                                                   ...flightPlanChangeCountDataAll.Count5min]
                                          })
                    // setTurbulenceCountDataAll([...turbulenceCountDataAll,jsonData.turbulenceCountData])
                    
                    var turbCountDataAddition = {epochString:[...jsonData.turbulenceCountData.epochString,
                                                              ...turbulenceCountDataAll.epochString]}

                    for(var idx in turbCountSectors){
                      var field = turbCountSectors[idx]+'5min'
                      if(Object.hasOwn(jsonData.turbulenceCountData,field)&&Object.hasOwn(turbulenceCountDataAll,field)){
                          turbCountDataAddition[field] = [...jsonData.turbulenceCountData[field],...turbulenceCountDataAll[field]]
                      }else if(Object.hasOwn(jsonData.turbulenceCountData,field)){
                        turbCountDataAddition[field] = jsonData.turbulenceCountData[field]
                      }
                    }
                    // Missing-data slots in the turbulence feed are scalars (null/NaN), not
                    // {15min:...} dicts; read defensively so a bad slot yields null instead of
                    // throwing.
                    var total15min = jsonData.turbulenceCountData['All'].map((counts)=>(counts && typeof counts === 'object') ? counts['15min'] : null)
                    if(Object.hasOwn(turbulenceCountDataAll,'Total15min')){
                      turbCountDataAddition['Total15min'] = [...total15min,...turbulenceCountDataAll['Total15min']]
                    }else{
                      turbCountDataAddition['Total15min'] = total15min
                    }
                    
                    setTurbulenceCountDataAll({...turbulenceCountDataAll,...turbCountDataAddition})
                    if(latestEpochFlag&&selectedEpoch===''){
                      if(metroplexEncroachmentDataAll.epochString.length>0){
                          setSelectedEpoch(metroplexEncroachmentDataAll.epochString[metroplexEncroachmentDataAll.epochString.length-1])
                          updateMapData(metroplexEncroachmentDataAll.epochString[metroplexEncroachmentDataAll.epochString.length-1],mapMetric)
                          
                      }else{
                          setSelectedEpoch(jsonData.metroplexEncroachmentData.epochString[jsonData.metroplexEncroachmentData.epochString.length-1])
                          updateMapData(jsonData.metroplexEncroachmentData.epochString[jsonData.metroplexEncroachmentData.epochString.length-1],mapMetric)
                      }
                    }

                    setIsChartLoading(false)
                  })
                  .catch(error => {
                    console.log(error);
                    setIsChartLoading(false)
                  });
        }else{

        }

    },[airport,queryIterTime])
    
    function getLatestMetricData(){

      axios.post(backendApiPrefix+'/api/get-metrics-all/latest/',{airport:airport})
                .then(response => {
                  var jsonData = response.data.message
                  console.log("CC",centerlineDeviationDataAll)
                  console.log("JJ",jsonData.centerlineDevData)
                  setMetroplexEncroachmentDataAll({...metroplexEncroachmentDataAll,
                                                      epochString:[...metroplexEncroachmentDataAll.epochString,jsonData.metroplexEncroachmentData.epochString],
                                                      encrDur:{
                                                        Total:[...metroplexEncroachmentDataAll.encrDur.Total,jsonData.metroplexEncroachmentData.encrDur.Total],
                                                        Adjusted:[...metroplexEncroachmentDataAll.encrDur.Adjusted,jsonData.metroplexEncroachmentData.encrDur.Adjusted]
                                                      }
                                                  })
                  setCenterlineDeviationDataAll({...centerlineDeviationDataAll,
                                                      epochString:[...centerlineDeviationDataAll.epochString,
                                                                      jsonData.centerlineDevData.epochString],
                                                      meanCenterlineDeviation_mean:[...centerlineDeviationDataAll.meanCenterlineDeviation_mean,
                                                                      jsonData.centerlineDevData.meanCenterlineDeviation_mean]})
                  setGoAroundCountDataAll({...goAroundCountDataAll,
                                                      epochString:[...goAroundCountDataAll.epochString,
                                                                      jsonData.goAroundCountData.epochString],
                                                      goAround15min:[...goAroundCountDataAll.goAround15min,
                                                                      jsonData.goAroundCountData.goAround15min],
                                                      holdingPattern15min:[...goAroundCountDataAll.holdingPattern15min,
                                                                      jsonData.goAroundCountData.holdingPattern15min]})

                  setFlightPlanChangeCountDataAll({...flightPlanChangeCountDataAll,
                                                      epochString:[...flightPlanChangeCountDataAll.epochString,
                                                                      jsonData.flightPlanChangeCountData.epochString],
                                                      Count5min:[...flightPlanChangeCountDataAll.Count5min,
                                                                      jsonData.flightPlanChangeCountData['5min']]
                                                      })
                  // setTurbulenceCountDataAll([...turbulenceCountDataAll,jsonData.turbulenceCountData])
                  
                  for(var idx in turbCountSectors){
                      var field = turbCountSectors[idx]+'5min'
                      if(Object.hasOwn(turbulenceCountDataAll,field)){
                          setTurbulenceCountDataAll({...turbulenceCountDataAll,
                                                        [field]:[...turbulenceCountDataAll[field],jsonData.turbulenceCountData[field]]})
                  }   
                } 

                })
                .catch(error => {
                  console.log(error);
                });

    };
    useEffect(() => {
                setPlotMapLayout({...plotMapLayout,
                                    mapbox: {...plotMapLayout.mapbox,
                                                center:{
                                                lat:airportData['location'][0],
                                                lon:airportData['location'][1]
                                                },
                                                bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                     'east':airportData['location'][1]+200*NM_TO_DEG,
                                                    'south':airportData['location'][0]-200*NM_TO_DEG,
                                                     'west':airportData['location'][1]-200*NM_TO_DEG},
                                    zoom:7}});
                                    
        setAirportMapTrace({...airportMapTrace,
                            lat: [airportData['location'][0]],
                            lon: [airportData['location'][1]],
                            text:[airport],
                            name:airport,
                            hovertemplate:'<extra></extra>'+airport,
                            })
    },[airportData])
    
    
    const mounted = useRef();
    useEffect(() => {
       if(mounted.current){
           // Component mounted
           console.log("Updated")
       } else {
            console.log("Mounted")
            mounted.current = true
            
       }
    });
    // const chartDiv = useCallback(node => {
        // if (node !== null) {
          // setLeftDivHeight(node.getBoundingClientRect().height);
          // setLeftDivWidth(node.getBoundingClientRect().width);
          // console.log("HEIGHT",height)
          // console.log("HEIGHT",width)
        // }
        // }, []);
    const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      // This will be called on both refresh and page close
      setIsRefreshing(true);
      setRevKey(prevVal => prevVal +1)
      // The following is necessary for older browsers
      event.preventDefault();
      event.returnValue = '';
    };

    
    window.addEventListener('load', handleBeforeUnload);

    return () => {
      window.removeEventListener('load', handleBeforeUnload);
    };
  });

  useEffect(() => {
    if (isRefreshing) {
      // This code will run when the component mounts after a refresh
      console.log('Page was refreshed');
      setPlotMapLayout({...plotMapLayout,
                                 mapbox: {...plotMapLayout.mapbox,
                                             center:{lat:airportData['location'][0],
                                                     lon:airportData['location'][1]},
                                             bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                      'east':airportData['location'][1]+200*NM_TO_DEG,
                                                     'south':airportData['location'][0]-200*NM_TO_DEG,
                                                      'west':airportData['location'][1]-200*NM_TO_DEG},
                                             accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
                                             zoom:7,
                                 }
                             });
                             
                                    
            setAirportMapTrace({...airportMapTrace,
                            lat: [airportData['location'][0]],
                            lon: [airportData['location'][1]],
                            text:[airport],
                            name:airport,
                            hovertemplate:'<extra></extra>'+airport,
                            })
      // Reset the state
      setIsRefreshing(false);
    }
  }, [isRefreshing]);
    // useEffect(() => {
        // const handleReload = () => {
           // console.log("RELOAD") 
           
           // setPlotMapLayout({...plotMapLayout,
                                 // mapbox: {...plotMapLayout.mapbox,
                                             // center:{lat:airportData['location'][0],
                                                     // lon:airportData['location'][1]},
                                             // bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                                                      // 'east':airportData['location'][1]+200*NM_TO_DEG,
                                                     // 'south':airportData['location'][0]-200*NM_TO_DEG,
                                                      // 'west':airportData['location'][1]-200*NM_TO_DEG},
                                             // accesstoken:"pk.eyJ1IjoidmFydW5zdWRhcnNhbmFuIiwiYSI6ImNscmpiazJ0cDAxb2IyaXFiaWQxY2hobHgifQ.oFJXYhV7inwFB3TeBwa86g",
                                             // zoom:7}
                             // });
                             
                                    
            // setAirportMapTrace({...airportMapTrace,
                            // lat: [airportData['location'][0]],
                            // lon: [airportData['location'][1]],
                            // text:[airport],
                            // name:airport,
                            // hovertemplate:'<extra></extra>'+airport,
                            // })
        // };

        // // Add the event listener for 'beforeunload' to detect window reload
        // window.addEventListener('beforeunload', handleReload);

        // // Cleanup function to remove the event listener when the component is unmounted
        // return () => {
          // window.removeEventListener('beforeunload', handleReload);
        // };
      // });
    var turbTrace = []
    for(var idx in turbCountSectors){
        var field = turbCountSectors[idx]+'5min'
        if(Object.hasOwn(turbulenceCountDataAll,field)){
        turbTrace.push({
                        x: turbulenceCountDataAll.epochString,
                        y: turbulenceCountDataAll[field],
                        type:'scatter',
                        mode:'lines',
                        hovertemplate:'%{y}<extra>'+field.split('5')[0]+'</extra>',
                        name:'Turbulence Count ('+field.split('5')[0]+')',
                        marker: {color: colorPalette[idx+1]},
                        xaxis:'x',
                        yaxis:'y6'
                          })
        }
        
    }        
 
    turbTrace.push({
                    x: turbulenceCountDataAll.epochString,
                    y: turbulenceCountDataAll['Total15min'],
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: colorPalette[12]},
                    hovertemplate:'%{y}<extra>Total</extra>',
                    name:'Turbulence Counts (Total)',
                    xaxis:'x',
                    yaxis:'y6',
                  })
        
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setLeftDivWidth(event[0].contentBoxSize[0].inlineSize);
            setLeftDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyChartDiv"));
        
        
    });
    
    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            // Depending on the layout, you may need to swap inlineSize with blockSize
            // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize
            setRightDivWidth(event[0].contentBoxSize[0].inlineSize);
            setRightDivHeight(event[0].contentBoxSize[0].inlineSize);
        });

        resizeObserver.observe(document.getElementById("plotlyMapDiv"));
    });
    const [menuOption, setMenuOption] = useState(1);
    const [mapMetric, setMapMetric] = useState(mapMetricValues[0])

    useEffect(()=>{
        var updateYHighlightMarker = {'index':1.2*Math.max(...metroplexEncroachmentDataAll.encrDur.Adjusted),
          'index2':1.2*Math.max(...centerlineDeviationDataAll.meanCenterlineDeviation_mean),
          'index3':1.2*Math.max(1,Math.max(...goAroundCountDataAll.goAround15min)),
          'index4':1.2*Math.max(1,Math.max(...goAroundCountDataAll.holdingPattern15min)),
          'index5':1.2*Math.max(1,Math.max(...flightPlanChangeCountDataAll.Count5min)),
          'index6':1.2*Math.max(1,Math.max(...turbulenceCountDataAll.Total15min)),
          }
        setHighlightYMarker(updateYHighlightMarker)
      
    },[selectedEpoch,plotChartLayout,metroplexEncroachmentDataAll,centerlineDeviationDataAll,goAroundCountDataAll,flightPlanChangeCountDataAll,
      turbulenceCountDataAll
    ])

    var highlightMarkerTraces = []
    for(var axNum of ['','2','3','4','5','6']){
      highlightMarkerTraces.push({ x:[selectedEpoch,selectedEpoch],
        y:[0,highlightYMarker['index'+axNum]],
        type:'scatter',
        xaxis:'x',yaxis:'y'+axNum,
        mode:'lines',
        showlegend:false,
        hoverinfo:'skip',
        line:{color:'black',dash:'dashdot'}})
    };
    const handleMenuSelection=(event: SelectChangeEvent) => {
        setMenuOption(String(event.target.value));
        setMapMetric(mapMetricValues[event.target.value-1])
        updateMapData(selectedEpoch,mapMetricValues[event.target.value-1])
        // setYRanges()
    };

    const handleMapTimeRangeChange=(event,newValue)=>{
      if(newValue){
        setMapTimeRange(newValue)
      }
      
    };

    const handleClickOnChart=(data)=>{
      console.log(data)
      setLatestEpochFlag(false)
      var point = data.points[0]
      
      if(!(new Date(point.x) instanceof Date && !isNaN(new Date(point.x).valueOf()))){
          return;
      }
      console.log(point)
      console.log(point.pointIndex)
      
      setSelectedEpoch(metroplexEncroachmentDataAll.epochString[point.pointIndex])
      updateMapData(metroplexEncroachmentDataAll.epochString[point.pointIndex],mapMetric)
      // setYRanges()
      // var updateYLabel = {yaxis:{...plotChartLayout.yaxis,range:[0,1.2*Math.max(...vectoringCountsDataAll.NumArrAC)]},
      //                     yaxis2:{...plotChartLayout.yaxis2,
      //                             range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Heading):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Heading)]},
      //                     yaxis3:{...plotChartLayout.yaxis3,
      //                             range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Speed):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Speed)]},
      //                     yaxis4:{...plotChartLayout.yaxis4,
      //                             range:[0,!normalizationFlag?1.2*Math.max(...vectoringCountsDataAll.NormalizedVectorCounts.Altitude):1.2*Math.max(...vectoringCountsDataAll.VectorCounts.Altitude)]}}
      // setPlotChartLayout({...plotChartLayout,...updateYLabel})
  };
  
    function updateMapData(epoch,metric){
        console.log(epoch)
        var metricApi = backendApiPrefix+'/api/'+apiSuffix[metric]+'/'
        axios.post(metricApi,{airport:airport,epoch:epoch})
          .then(response =>{
              var jsonData = response.data.message
              console.log(jsonData)
              setMapData(jsonData)
              setIsMapLoading(false)
          }).catch(error => {
            console.log(error);
            setIsMapLoading(false)
          });

    };
    useEffect(()=>{

    },[mapTimeRange])

    useEffect(()=>{
      var traceData = {type: "scattermapbox", lon:mapData[mapTimeRange]['lon'], 
                                lat:mapData[mapTimeRange]['lat'], 
                                text:mapData[mapTimeRange]['alt'],
                                customdata:mapData[mapTimeRange]['additionalData'],
                        name:mapMetric,radius: 50,
                        hovertemplate:'<extra></extra>%{customdata[0]}<br>Lat:%{lat}, Lon:%{lon}, Alt:%{text}ft'}
      if(mapMetric === 'turbulence'){
          traceData['marker'] = {color: mapData[mapTimeRange]['turbIntensityVal'], size: 15, cmin:TURB_INTENSITY_SCALE[0],cmax:TURB_INTENSITY_SCALE[1]}
          traceData['hovertemplate'] = traceData['hovertemplate']+'<br>Type:%{customdata[1]}, Intensity:%{customdata[2]}'
      }else if(mapMetric === 'flightplanchanges'){
          traceData['marker'] = {color:'rgba(28, 167, 28,0.6)',size:15}
          traceData['hovertemplate'] = traceData['hovertemplate']+'<br>Old FlightPlan:%{customdata[1]},<br>New FlightPlan:%{customdata[2]}'
      };
      console.log("HERE")
      console.log(traceData)
      setMapPlotTraces([traceData])
    },[mapData,mapTimeRange])
    const handleLatestEpochButton=()=>{
      setLatestEpochFlag(true)
      setSelectedEpoch(metroplexEncroachmentDataAll.epochString[metroplexEncroachmentDataAll.epochString.length-1])
    };
    const handleDoubleClickOnMap=(data)=>{
        setPlotMapLayout({...plotMapLayout,
            mapbox: {...plotMapLayout.mapbox,
                        center:{
                        lat:airportData['location'][0],
                        lon:airportData['location'][1]
                        },
                        bounds:{'north':airportData['location'][0]+200*NM_TO_DEG,
                             'east':airportData['location'][1]+200*NM_TO_DEG,
                            'south':airportData['location'][0]-200*NM_TO_DEG,
                             'west':airportData['location'][1]-200*NM_TO_DEG},
            zoom:7}});
    }
    return (
        <Layout>
        <PlotSectionDiv id="chartPlotDiv" flexRatio={1}>
            <PlotLoadingOverlay show={isChartLoading}/>
            <EpochDataBlock selectedEpoch={metroplexEncroachmentDataAll.epochString[metroplexEncroachmentDataAll.epochString.length-1]}
                            handleLatestEpochButton={handleLatestEpochButton}
                            lastUpdatedTime={lastUpdatedTime}/>
            <Plot  data={[{
                    x: metroplexEncroachmentDataAll.epochString,
                    y: metroplexEncroachmentDataAll.encrDur.Adjusted,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: 'rgba(255,0,0,0.4)'},
                    name:'Adjusted Encroachment Duration',
                    hovertemplate:'%{y}<extra>Adj. EncrDur [s]</extra>',
                    xaxis:'x',
                    yaxis:'y',
                  },
                  {
                    x: centerlineDeviationDataAll.epochString,
                    y: centerlineDeviationDataAll.meanCenterlineDeviation_mean,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: 'rgba(0,0,255,0.4)'},
                    name:'Centerline Deviation',
                    hovertemplate:'%{y}<extra>Mean Deviation [ft]</extra>',
                    xaxis:'x',
                    yaxis:'y2'
                  },
                  {
                    x: goAroundCountDataAll.epochString,
                    y: goAroundCountDataAll.goAround15min,
                    type:'scatter',
                    mode:'lines',
                    marker: {color: 'rgba(0,255,0,0.4)'},
                    name:'Go Around Counts',
                    hovertemplate:'%{y}<extra>15 min counts</extra>',
                    xaxis:'x',
                    yaxis:'y3'
                  },
                  {
                    x: goAroundCountDataAll.epochString,
                    y: goAroundCountDataAll.holdingPattern15min,
                    type:'scatter',
                    mode:'lines',
                    marker: {color: 'rgba(125,25,120,0.4)'},
                    name:'Holding Patterns',
                    hovertemplate:'%{y}<extra>15 min counts</extra>',
                    xaxis:'x',
                    yaxis:'y4'
                  },
                  {
                    x: flightPlanChangeCountDataAll.epochString,
                    y: flightPlanChangeCountDataAll.Count5min,
                    type: 'scatter',
                    mode: 'lines',
                    marker: {color: colorPalette[0]},
                    hovertemplate:'%{y}<extra>Counts</extra>',
                    name: 'Flight Plan Change Counts',
                    xaxis:'x',
                    yaxis:'y5',
                  },
                  ...turbTrace,
                  ...highlightMarkerTraces
                      
                ]}
                layout= {plotChartLayout}
                config= {plotConfig}
                divId={'plotlyChartDiv'}
                onClick={handleClickOnChart}
                style={{minWidth:'300px',height:'95%',position:'relative'}}
                useResizeHandler={true}
              />
        </PlotSectionDiv>
        <PlotSectionDiv id="mapPlotDiv" key={revKey} flexRatio={1}>
            <PlotLoadingOverlay show={isMapLoading} label="Loading map…"/>
            <Box sx={{mb:1,mt:2,ml:2,mr:3}}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label"></InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={menuOption}
                  label=""
                  onChange={handleMenuSelection}
                  sx={{height:30}}
                >
                  <MenuItem value={1}>Turbulence Events</MenuItem>
                  <MenuItem value={2}>Flight Plan Change Events</MenuItem>
                  
                </Select>
              </FormControl>
              <Box sx={{mb:-1,mt:1,ml:0,mr:0}}>
              <ToggleButtonGroup fullWidth
                  color="primary"
                  value={mapTimeRange}
                  exclusive
                  onChange={handleMapTimeRangeChange}
                  aria-label="Platform"
                  sx={{height:30}}
                >
                  <ToggleButton value="5min">5 Minutes</ToggleButton>
                  <ToggleButton value="1hr">1 Hour</ToggleButton>
                  <ToggleButton value="24hr">24 Hours</ToggleButton>
              </ToggleButtonGroup>
              </Box>
            </Box>
            <Plot data={[airportMapTrace,...mapPlotTraces]}
                  layout= {plotMapLayout}
                  config= {{...plotConfig,scrollZoom:true}}
                  useResizeHandler={true}
                  onDoubleClick={handleDoubleClickOnMap}
                  onMapLongClick={()=>{}}
                  divId={'plotlyMapDiv'}
                  style={{minWidth:'300px',height:'90%',position:'relative',borderWidth:'2px',color:'yellow',
                            borderSyle:'solid',
                            borderColor:'black'}}
            />
        </PlotSectionDiv>  
        </Layout>
    );
};

export default AirportSummary